import React from "react";
import { Label, Menu } from "semantic-ui-react";

export function VersionCard() {
  return (
    <Menu.Item disabled>
      <Label color="purple">Ver. {global.version}</Label>
    </Menu.Item>
  );
}
